import { captainBillingKeys } from "./query-keys";
import { CAPTAIN_BALANCE_CHANGED } from "../constants";
import type { CaptainBillingAccount } from "../types";

import type { ClientRealtimeFeature } from "@/features/realtime";

export const captainBillingRealtime: ClientRealtimeFeature = {
  events: {
    [CAPTAIN_BALANCE_CHANGED]: async (queryClient, payload) => {
      const account = payload as CaptainBillingAccount;
      queryClient.setQueryData(captainBillingKeys.account(account.clientId), account);
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: captainBillingKeys.histories(account.clientId) }),
        queryClient.invalidateQueries({ queryKey: captainBillingKeys.usages(account.clientId) }),
      ]);
    },
  },
  resetKey: captainBillingKeys.all,
};
